export function distinctByDescription(lista) {
  const unique = [...new Set(lista.map(item => {
    return item.estado.descripcion
  }))];
  
  return unique;
}

export function distinctByState(lista) {
  const unique = [...new Set(lista.map(item => {
    return item.estado
  }))];
  
  return unique;
}

export function distinctByExceptionCategory(lista) {
  const unique = [...new Set(lista.map(item => {
    return item.tipo.nombre
  }))];
  
  return unique;
}

export function distinctByExceptionStatus(lista) {
  const unique = [...new Set(lista.map(item => {
    return item.solicitudExcepciones.estado
  }))];

  return unique;
}
